/**
 * isMobileDevice
 * @return boolean
 */
export function isMobileDevice() {
    if (navigator.userAgentData?.mobile) return true;
    if (window.matchMedia("(pointer: coarse)").matches) return true;
    return /iphone|ipad|ipod|android|mobile/i.test(navigator.userAgent);
}
